import { onKeyDown } from '../../../../service'
import classes from './Training.module.css'

const Training = ({ name, description, img,onClick }) => {
    return (
        <div className={classes.TrainingContainer} >
            <div className={classes.IframeWarrper} style={{ backgroundImage: `url(${img})` }} onClick={onClick} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, onClick)}> </div>
            <div className={classes.Title}>{name}</div>
            <div className={classes.Description}>{description}</div>
        </div>
    )
}
export default Training